import { render } from "./InterfaceConfirmRedeem.vue?vue&type=template&id=56f9abc5"
import script from "./InterfaceConfirmRedeem.vue?vue&type=script&lang=js"
export * from "./InterfaceConfirmRedeem.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__